(function () {
    'use strict';

    function initAccueilNosProduits() {
        var buttons = document.querySelectorAll('.accueil-produit-zone-btn');
        var panels = document.querySelectorAll('.accueil-produits-panel');

        if (!buttons.length || !panels.length) {
            return;
        }

        buttons.forEach(function (btn) {
            btn.addEventListener('click', function () {
                var zoneId = btn.getAttribute('data-zone-target');
                if (!zoneId) {
                    return;
                }

                buttons.forEach(function (other) {
                    other.classList.remove('is-active');
                    other.setAttribute('aria-pressed', 'false');
                });
                btn.classList.add('is-active');
                btn.setAttribute('aria-pressed', 'true');

                panels.forEach(function (panel) {
                    if (panel.getAttribute('data-zone-panel') === zoneId) {
                        panel.classList.remove('d-none');
                    } else {
                        panel.classList.add('d-none');
                    }
                });
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAccueilNosProduits);
    } else {
        initAccueilNosProduits();
    }
})();
